const common = {
  Selected : 'selected',
  FormId: 'form_id',
  CommonId: 'common_id',
  RefNo: 'ref_number',
  SequenceId: 'sequence_id',
  StatusId: 'status_id',
  StatusName: 'status_name',
  StatusColor: 'status_color',
  StockId: 'stock_id',
  StockName: 'stock_name',
  TypeId: 'type_id',
  TypeName: 'type_name',
  DefaultId: 'default_id',
  DefaultName: 'default_name',
  UnitId: 'unit_id',
  UnitName: 'unit_name',
  GenderId: 'gender_id',
  GenderName: 'gender_name',
  CreditId: 'credit_id',
  CreditName: 'credit_name',
  TermId: 'term_id',
  TermName: 'term_name',
  SegmentId: 'segment_id',
  SegmentName: 'segment_name',
  SpecificationId: 'specification_id',
  SpecificationName: 'specification_name',
  CurrencyId: 'currency_id',
  CurrencyName: 'currency_name',
  TitleId: 'title_id',
  TitleName: 'title_name',
  MaritalId: 'marital_id',
  MaritalName: 'marital_Name',
  BloodGroupId: 'blood_group_id',
  BloodGroupName: 'blood_group_Name',
  LanguageId: 'language_id',
  LanguageName: 'language_name',
  CategoryId: 'category_id',
  CategoryName: 'category_name',
  ModeId: 'mode_id',
  ModeName: 'mode_name',
  GroupId: 'group_id',
  GroupName: 'group_name',
  ActionId: 'action_id',
  ActionName: 'action_name',
  insurer1Id: 'insurer1_id',
  insurer1Name: 'insurer1_name',
  insurer2Id: 'insurer2_id',
  insurer2Name: 'insurer2_name',
  SpecializationId: 'specialization_id',
  SpecializationName: 'specialization_name',
  PriorityId: 'priority_id',
  PriorityName: 'priority_name',
  SenderId: 'sender_id',
  SenderName: 'sender_name',
  ReceiverId: 'receiver_id',
  ReceiverName: 'receiver_name',
  ReplyId: 'reply_id',
  ReplyName: 'reply_name',
  BranchId: 'branch_id', // Branch where appointment is scheduled
  BranchName: 'branch_name', // Branch where appointment is scheduled
  ContactMode: 'contact_mode_id',
  ContactModeName: 'contact_mode_name',
  FolderId: 'folder_id',
  FolderName: 'folder_name',
  IssueId: 'issue_id',
  IssueName: 'issue_name',
  FormatId: 'format_id',
  FormatName: 'format_name',
  OccupationId: 'occupation_id',
  OccupationName: 'occupation_name',
  PostCheckId: 'postcheck_id',
  PostCheckName: 'postcheck_name',
  data1: 'data1',
  data2: 'data2',
  data3: 'data3',
  data4: 'data4',
  data5: 'data5',
  data6: 'data6',
  data7: 'data7',
  data8: 'data8',
};

const user =  {
  Id: 'user_id',
  Key: 'user_key',
  Active: 'user_active',
  Date: 'user_date',
  FirstName: 'user_first_name',
  MiddleName: 'user_middle_name',
  LastName: 'user_last_name',
  FullName: 'user_first_name,user_middle_name,user_last_name',
  Login: 'user_login',
  Pass: 'user_pass',
  Phone: 'user_phone',
  Email: 'user_email',
  Address: 'user_address',
  Postal: 'user_postal',
  MfaId: 'mfa_id',
  MfaData: 'mfa_data',
  menuList: 'menu_list',
  doctorList: 'doctor_list',
  deviceLimit: 'device_limit',
  attemptTime: 'attempt_time',
};

const insurer = {
  Id: 'insurer_id',
  Key: 'insurer_key',
  Active: 'insurer_active',
  Date: 'insurer_date',
  Name: 'insurer_name',
  Address: 'insurer_address',
  Postal: 'insurer_postal',
  Comment: 'insurer_comment',
  Phone: 'insurer_phone',
  Email: 'insurer_email',
  Website: 'insurer_website',
  Fax: 'insurer_fax',
  ContactPerson: 'contact_person',
  ContactCell: 'contact_cell',
  License: 'insurer_license',
  Tax: 'insurer_tax',
  Registration: 'insurer_registration',
  Limit: 'insurer_limit',
};

const company = {
  Id: 'company_id',
  Key: 'company_key',
  Active: 'company_active',
  Date: 'company_date',
  ServerId: 'server_id',
  DatabaseId: 'database_id',
  Name: 'company_name',
  LegalName: 'company_legal_name',
  Path: 'company_path',
  Phone: 'company_phone',
  Email: 'company_email',
  Website: 'company_website',
  Address: 'company_address',
  Postal: 'company_postal',
  FeatureList: 'feature_list',
  FileList: 'file_list',
};

const database = {
  Id: 'database_id',
  Key: 'database_key',
  Active: 'database_active',
  Date: 'database_date',
  Name: 'database_name',
  Server: 'database_server',
  Port: 'database_port',
  DbName: 'database_dbname',
  User: 'database_user',
  Pass: 'database_pass',
  Comment: 'database_comment',
};

const code = {
  Id: 'code_id',
  Auth: 'code_auth',
  Created: 'code_created',
  Expiry: 'code_expiry',
  UserId: 'user_id',
  UserName: 'user_name',
  UserEmail: 'user_email',
};

const feature = {
  Id: 'feature_id',
  Key: 'feature_key',
  Active: 'feature_active',
  Date: 'feature_date',
  Name: 'feature_name',
  Comment: 'feature_comment',
};

const form = {
  Id: 'form_id',
  Key: 'form_key',
  Active: 'form_active',
  Name: 'form_name',
  Comment: 'form_comment',
  Path: 'form_path',
  Icon: 'form_icon',
  Info: 'form_info',
  Sorting: 'form_sorting',
  FeatureId: 'feature_id',
};

const location = {
  Id: 'location_id',
  Key: 'location_key',
  Active: 'location_active',
  Date: 'location_date',
  Name: 'location_name',
  Phone: 'location_phone',
  Email: 'location_email',
  Website: 'location_website',
  Path: 'location_path',
  Address: 'location_address',
  Postal: 'location_postal',
  Print: 'location_print',
  FileList: 'file_list',
};

const logs = {
  Id: 'logs_id',
  Key: 'logs_key',
  Active: 'logs_active',
  Date: 'logs_date',
  Ip: 'logs_ip',
  Value: 'logs_value',
};

const officehour = {
  Id: 'officehour_id',
  Key: 'officehour_key',
  Active: 'officehour_active',
  Date: 'officehour_date',
  Day: 'officehour_day',
  Start: 'officehour_start',
  End: 'officehour_end',
};

const privilege = {
  Id: 'privilege_id',
  Key: 'privilege_key',
  Active: 'privilege_active',
  Date: 'privilege_date',
  Name: 'privilege_name',
  Comment: 'privilege_comment',
};

const server = {
  Id: 'server_id',
  Key: 'server_key',
  Active: 'server_active',
  Date: 'server_date',
  Name: 'server_name',
  Ip: 'server_ip',
  Data: 'server_data',
  Comment: 'server_comment',
};

const session = {
  Id: 'session_id',
  Key: 'session_key',
  Active: 'session_active',
  Date: 'session_date',
  AuthKey: 'auth_key',
  Validity: 'session_validity',
  Ip: 'session_ip',
};

const setting = {
  Id: 'setting_id',
  Key: 'setting_key',
  Active: 'setting_active',
  Date: 'setting_date',
  Value: 'setting_value',
  Comment: 'setting_comment',
};

const timezone = {
  Id: 'timezone_id',
  Key: 'timezone_key',
  Active: 'timezone_active',
  Name: 'timezone_name',
  Abbreviation: 'timezone_abbreviation',
  Dst: 'timezone_dst',
  Offset: 'timezone_offset',
  DstOffset: 'timezone_dst_offset',
  Country: 'timezone_country',
  Region: 'timezone_region',
  Comment: 'timezone_comment',
};

const token = {
  Id: 'token_id',
  Refresh: 'token_refresh',
  Access: 'token_access',
  Created: 'token_created',
  IsValid: 'token_isvalid',
  UserId: 'user_id',
};

const address = {
  Id: 'address_id',
  Key: 'address_key',
  Active: 'address_active',
  Date: 'address_date',
  Street: 'address_street',
  Postal: 'address_postal',
};

const missing = {
  Id: 'missing_id',
  Key: 'missing_key',
  Active: 'missing_active',
  Date: 'missing_date',
  Comment: 'missing_comment',
  Amount: 'missing_amount',
  RefNumber: 'missing_ref_number',
};

const appointment = {
  Id: 'appointment_id',
  Key: 'appointment_key',
  Active: 'appointment_active',
  Date: 'appointment_date',
  StartDate: 'appointment_start_date',
  EndDate: 'appointment_end_date',
  StartTime: 'appointment_start_time',
  EndTime: 'appointment_end_time',
  Comment: 'appointment_comment',
  NewOld: 'newold_id',
};


const billing = {
  Id: 'billing_id',
  Key: 'billing_key',
  Active: 'billing_active',
  BillingDate: 'billing_date',
  ClaimDate: 'claim_date',
  RemittanceDate: 'remittance_date',
  Sequence: 'billing_sequence',
  Action: 'billing_action',
  Serial: 'billing_serial',
  Number: 'billing_number',
  RefNo: 'billing_ref_number',
  Price: 'billing_price',
  Quantity: 'billing_quantity',
  Taxable: 'billing_taxable',
  TaxPercentage: 'billing_tax_percentage',
  TaxAmount: 'billing_tax_amount',
  Amount: 'billing_amount',
  InsuranceAmount: 'billing_insurance_amount',
  Hsc: 'billing_hsc_id',
  HscName: 'billing_hsc_name',
  Diagnosis1: 'billing_diagnosis1_id',
  Diagnosis1Name: 'billing_diagnosis1_name',
  Diagnosis2: 'billing_diagnosis2_id',
  Diagnosis21Name: 'billing_diagnosis2_name',
  Diagnosis3: 'billing_diagnosis3_id',
  Diagnosis31Name: 'billing_diagnosis3_name',
  ActionCode: 'billing_action_code',
  GovKey: 'billing_govkey',
  ExplanatoryCode: 'billing_explanatory_code',
  Data: 'billing_data',
  History: 'billing_history',
  Comment: 'billing_comment',
  Remittance: 'billing_remittance',
  Modifier1: 'billing_modifier1',
  Modifier2: 'billing_modifier2',
  Modifier3: 'billing_modifier3',
};


const category = {
  Id: 'category_id',
  Key: 'category_key',
  Active: 'category_active',
  Date: 'category_date',
  Name: 'category_name',
  Comment: 'category_comment',
  Term: 'category_term',
  PriorityId: 'priority_id',
  MarginRate: 'margin_rate',
};

const chat = {
  Id: 'chat_id',
  Key: 'chat_key',
  Active: 'chat_active',
  Date: 'chat_date',
  Data: 'chat_data',
};

const check = {
  Id: 'check_id',
  Key: 'check_key',
  Active: 'check_active',
  Date: 'check_date',
  Number: 'check_no',
  Amount: 'check_amount',
  Comment: 'check_comment',
};

const claim = {
  Id: 'claim_id',
  Key: 'claim_key',
  Active: 'claim_active',
  Date: 'claim_date',
  Serial: 'claim_serial',
  Number: 'claim_number',
  Count: 'claim_count',
  BillList: 'bill_list',
  Comment: 'claim_comment',
  RefNo: 'claim_ref_number',
};

const client = {
  Id: "client_id",
  Key: "client_key",
  CompanyId: "company_id",
  LocationId: "location_id",
  UserId: "user_id",
  Active: "client_active",
  Date: "client_date",
  FamilyId: "client_family_id",
  Serial: 'client_serial',
  Number: 'client_number',
  FirstName: "client_first_name",
  MiddleName: "client_middle_name",
  LastName: "client_last_name",
  FullName: "client_first_name,client_middle_name,client_last_name",
  Dob: "client_dob",
  HealthCard: "client_health_card",
  Cell: "client_cell",
  Phone: "client_phone",
  Mobile: "client_mobile",
  Email: "client_email",
  Fax: "client_fax",
  File: "client_file",
  Referby: "client_referby",
  RefNo: "client_ref_number",
  MedNo: "client_med_number",
  Comment: "client_comment",
  Data: "client_data",
  Address: "client_address",
  Postal: "client_postal",
  MedDeptId: "med_department_id"
};

const communication = {
  Id: 'communication_id',
  Key: 'communication_key',
  Active: 'communication_active',
  Date: 'communication_date',
  SendId: 'send_id',
  StatusId: 'status_id',
  TemplateId: 'template_id',
  Contact: 'communication_contact',
  Subject: 'communication_subject',
  Body: 'communication_body',
};

const control = {
  Id: 'control_id',
  Key: 'control_key',
  Active: 'control_active',
  Date: 'control_date',
  RequiredId: 'required_id',
  Name: 'control_name',
  Comment: 'control_comment',
  Info: 'control_info',
  Values: 'control_values',
  Metadata: 'control_metadata',
  Width: 'control_width',
  Height: 'control_height',
  Sorting: 'control_sorting',
  Style: 'control_style',
};

const credit = {
  Id: 'credit_id',
  Key: 'credit_key',
  Active: 'credit_active',
  Date: 'credit_date',
  Amount: 'credit_amount',
  RefNo: 'credit_ref_number',
  Comment: 'credit_comment',
};

const daybook = {
  Id: 'daybook_id',
  Key: 'daybook_key',
  Active: 'daybook_active',
  Date: 'daybook_date',
  Comment: 'daybook_comment',
  Data: 'daybook_data',
  Info: 'daybook_info',
  Denomination: 'daybook_denomination',
  CashTotal: 'daybook_cash_total',
  TerminalTotal: 'daybook_terminal_total',
  CheckTotal: 'daybook_check_total',
  InsuranceTotal: 'daybook_insurance_total',
  GiftTotal: 'daybook_gift_total',
  CommissionTotal: 'daybook_commission_total',
  CreditTotal: 'daybook_credit_total',
  PayoutTotal: 'daybook_payout_total',
  GrandTotal: 'daybook_grand_total',
  CashInHand: 'daybook_cash_in_hand',
  CashOpen: 'daybook_cash_opening',
  CashAdjustment: 'daybook_cash_adjustment',

  segment: 'segment',
  terminal: 'terminal',
  insurance: 'insurance',
  cash: 'cash',
  check: 'check',
  giftcard: 'giftcard',
  total: 'total',

  dollar100: 'dollar100',
  dollar50: 'dollar50',
  dollar20: 'dollar20',
  dollar10: 'dollar10',
  dollar5: 'dollar5',
  dollar2: 'dollar2',
  dollar1: 'dollar1',
  cent50: 'cent50',
  cent25: 'cent25',
  cent10: 'cent10',
  cent5: 'cent5',
};

const delivery = {
  Id: 'delivery_id',
  Key: 'delivery_key',
  Active: 'delivery_active',
  Date: 'delivery_date',
  TermId: 'term_id',
  Serial: 'delivery_serial',
  Number: 'delivery_number',
  PoNumber: 'delivery_po_number',
  RefNo: 'delivery_ref_number',
  Gross: 'delivery_gross',
  Discount: 'delivery_discount_amount',
  Deposit: 'delivery_deposit_amount',
  Taxable: 'delivery_taxable_amount',
  Tax1: 'delivery_tax1_amount',
  Tax2: 'delivery_tax2_amount',
  Tax3: 'delivery_tax3_amount',
  Tax4: 'delivery_tax4_amount',
  Tax5: 'delivery_tax5_amount',
  Tax: 'delivery_tax_amount',
  Roundoff: 'delivery_roundoff',
  Net: 'delivery_net_amount',
  Payable: 'delivery_payable_amount',
  Comment: 'delivery_comment',
  InternalNote: 'delivery_internal_note',
  PrintableNote: 'delivery_printable_note',
};

const dispense = {
  Id: 'dispense_id',
  Key: 'dispense_key',
  Active: 'dispense_active',
  Date: 'dispense_date',
  TermId: 'term_id',
  Serial: 'dispense_serial',
  Number: 'dispense_number',
  PoNumber: 'dispense_po_number',
  RefNo: 'dispense_ref_number',
  Gross: 'dispense_gross',
  Discount: 'dispense_discount_amount',
  Deposit: 'dispense_deposit_amount',
  Taxable: 'dispense_taxable_amount',
  Tax1: 'dispense_tax1_amount',
  Tax2: 'dispense_tax2_amount',
  Tax3: 'dispense_tax3_amount',
  Tax4: 'dispense_tax4_amount',
  Tax5: 'dispense_tax5_amount',
  Tax: 'dispense_tax_amount',
  Roundoff: 'dispense_roundoff',
  Net: 'dispense_net_amount',
  Payable: 'dispense_payable_amount',
  Comment: 'dispense_comment',
  InternalNote: 'dispense_internal_note',
  PrintableNote: 'dispense_printable_note',
  PrintableName: 'dispense_name',
  PrintablePhone: 'dispense_phone',
};

const release = {
  Id: 'release_id',
  Key: 'release_key',
  Active: 'release_active',
  Date: 'release_date',
  TermId: 'term_id',
  Serial: 'release_serial',
  Number: 'release_number',
  PoNumber: 'release_po_number',
  RefNo: 'release_ref_number',
  Gross: 'release_gross',
  Discount: 'release_discount_amount',
  Deposit: 'release_deposit_amount',
  Taxable: 'release_taxable_amount',
  Tax1: 'release_tax1_amount',
  Tax2: 'release_tax2_amount',
  Tax3: 'release_tax3_amount',
  Tax4: 'release_tax4_amount',
  Tax5: 'release_tax5_amount',
  Tax: 'release_tax_amount',
  Roundoff: 'release_roundoff',
  Net: 'release_net_amount',
  Payable: 'release_payable_amount',
  Comment: 'release_comment',
  InternalNote: 'release_internal_note',
  PrintableNote: 'release_printable_note',
};

const dispatch = {
  Id: 'dispatch_id',
  Key: 'dispatch_key',
  Active: 'dispatch_active',
  Date: 'dispatch_date',
  Type: 'dispatch_type',
  Serial: 'dispatch_serial',
  Number: 'dispatch_number',
  RefNo: 'dispatch_ref_number',
};

const document = {
  Id: 'document_id',
  Key: 'document_key',
  Active: 'document_active',
  Date: 'document_date',
  Name: 'document_name',
  Comment: 'document_comment',
  FileName: 'document_file_name',
  FileNo: 'document_file_no',
  RefNo: 'document_refno',
  IssueDate: 'document_issue_date',
  ExpiryDate: 'document_expiry_date',
};

const estimate = {
  Id: 'estimate_id',
  Key: 'estimate_key',
  Active: 'estimate_active',
  Date: 'estimate_date',
  StartDate: 'estimate_start_date',
  EndDate: 'estimate_end_date',
  CreditId: 'credit_id',
  Serial: 'estimate_serial',
  Number: 'estimate_number',
  PoNumber: 'estimate_po_number',
  RefNo: 'estimate_ref_number',
  Gross: 'estimate_gross_amount',
  Discount: 'estimate_discount_amount',
  Deposit: 'estimate_deposit_amount',
  Taxable: 'estimate_taxable_amount',
  Tax1: 'estimate_tax1_amount',
  Tax2: 'estimate_tax2_amount',
  Tax3: 'estimate_tax3_amount',
  Tax4: 'estimate_tax4_amount',
  Tax5: 'estimate_tax5_amount',
  Tax: 'estimate_tax_amount',
  Net: 'estimate_net_amount',
  Roundoff: 'estimate_roundoff_amount',
  Payable: 'estimate_payable_amount',
  Insurer1: 'estimate_insurer1_amount',
  Insurer2: 'estimate_insurer2_amount',
  Client: 'estimate_client_amount',
  Adjustment: 'estimate_adjustment_amount',
  Giftcard: 'estimate_giftcard_amount',
  GiftCardMode: 'estimate_giftcard_mode',
  Comment: 'estimate_comment',
  InternalNote: 'estimate_internal_note',
  PrintableNote: 'estimate_printable_note',
}

const exam = {
  Id: 'exam_id',
  Key: 'exam_key',
  Active: 'exam_active',
  Date: 'exam_date',
  TermId: 'term_id',
  LensId: 'lens_id',
  AppointmentTypeId: 'appointment_type_id',
  AppointmentTypeName: 'appointment_type_name',
  Serial: 'exam_serial',
  Number: 'exam_number',
  RefNo: 'exam_ref_number',
  Name: 'exam_name',
  Comment: 'exam_comment',
  Data: 'exam_data',
  Data1: 'exam_data1',
  Data2: 'exam_data2',
  Data3: 'exam_data3',
};

const examtemplate = {
  Id: 'examtemplate_id',
  Key: 'examtemplate_key',
  Active: 'examtemplate_active',
  Date: 'examtemplate_date',
  Name: 'examtemplate_name',
  Comment: 'examtemplate_comment',
  Data: 'examtemplate_data',
};

const examtype = {
  Id: 'examtype_id',
  Key: 'examtype_key',
  Active: 'examtype_active',
  Date: 'examtype_date',
  Name: 'examtype_name',
  Comment: 'examtype_comment',
  FormList: 'form_list',
};

const group = {
  Id: 'group_id',
  Key: 'group_key',
  Active: 'group_active',
  Date: 'group_date',
  Name: 'group_name',
  Comment: 'group_comment',
  Priority: 'group_priority',
  Sorting: 'group_sorting',
};

const inquiry = {
  Id: 'inquiry_id',
  Key: 'inquiry_key',
  Active: 'inquiry_active',
  Date: 'inquiry_date',
  ResponseId: 'response_id',
  ResponseName: 'response_name',
  DurationId: 'duration_id',
  DurationName: 'duration_Name',
  InterestId: 'interest_id',
  InterestName: 'interest_name',
  Address: 'inquiry_address',
  Postal: 'inquiry_postal',
  Serial: 'inquiry_serial',
  Number: 'inquiry_number',
  Name: 'inquiry_name',
  Phone: 'inquiry_phone',
  Email: 'inquiry_email',
  ReferBy: 'inquiry_referby',
  FollowupDate: 'inquiry_followup_date',
  StartDate: 'inquiry_start_date',
  EndDate: 'inquiry_end_date',
  Comment: 'inquiry_comment',
};

const insurance = {
  Id: 'insurance_id',
  Key: 'insurance_key',
  Active: 'insurance_active',
  Date: 'insurance_date',
  CoverageId: 'coverage_id',
  PolicyNumber: 'insurance_policy_number',
  GroupNumber: 'insurance_group_number',
  memberNumber: 'insurance_member_number',
  IssueDate: 'insurance_issue_date',
  ExpiryDate: 'insurance_expiry_date',
  PrimaryHolderName: 'primary_holder_name',
  PrimaryRelationship: 'primary_relationship',
  SecondaryHolderName: 'secondary_holder_name',
  SecondaryRelationship: 'secondary_relationship',
  Comment: 'insurance_comment',
  RefNumber: 'insurance_ref_number',
  Data: 'insurance_data',
};

const specification = {
  Id: 'specification_id',
  Key: 'specification_key',
  Active: 'specification_active',
  Date: 'specification_date',
  Name: 'specification_name',
  Comment: 'specification_comment',
  Prefix: 'specification_prefix',
};

const inventory = {
  Id: 'inventory_id',
  Key: 'inventory_key',
  Active: 'inventory_active',
  Date: 'inventory_date',
  Name: 'inventory_name',
  Data: 'inventory_data',
  Comment: 'inventory_comment',
  Sale: 'inventory_sale_price',
  Purchase: 'inventory_purchase_price',
  Deposit: 'inventory_deposit_price',
  Cost: 'inventory_cost_price',
  Paid: 'inventory_paid_price',
  Stock: 'inventory_stock',
  UTN: 'inventory_utncode',
  SKU: 'inventory_skucode',
  SerialNo: 'inventory_serialno',
  RefNo: 'inventory_ref_number'
};

const issue = {
  Id: 'issue_id',
  Key: 'issue_key',
   Active: 'issue_active',
  Date: 'issue_date',
  Name: 'issue_name',
  Comment: 'issue_comment',
};

const language = {
  Id: 'language_id',
  Key: 'language_key',
  Active: 'language_active',
  Date: 'language_date',
  Name: 'language_name',
  Comment: 'language_comment',
};

const medication = {
  Id: 'medication_id',
  Key: 'medication_key',
  Active: 'medication_active',
  Date: 'medication_date',
  Name: 'medication_name',
  Comment: 'medication_comment',
};

const merge = {
  Id: 'merge_id',
  Key: 'merge_key',
  Active: 'merge_active',
  Date: 'merge_date',
  ClientId1: 'client_id1',
  ClientId2: 'client_id2',
  MergeData: 'merge_data',
};

const metric = {
  Id: 'metric_id',
  Key: 'metric_key',
  Active: 'metric_active',
  Date: 'metric_date',
  LevelId: 'level_id',
  MetricLimit: 'metric_limit',
  MetricComment: 'metric_comment',
};

const note = {
  Id: 'note_id',
  Key: 'note_key',
  Active: 'note_active',
  Date: 'note_date',
  Comment: 'note_comment',
};

const orders = {
  Id: 'orders_id',
  Key: 'orders_key',
  Active: 'orders_active',
  Date: 'orders_date',
  ExamRxId: 'exam_rx_id',
  Serial: 'ordesr_serial',
  Number: 'orders_number',
  RefNo: 'orders_ref_number',
  Gross: 'orders_gross_amount',
  Discount: 'orders_discount_amount',
  Deposit: 'orders_deposit_amount',
  Taxable: 'orders_taxable_amount',
  Tax1: 'orders_tax1_amount',
  Tax2: 'orders_tax2_amount',
  Tax3: 'orders_tax3_amount',
  Net: 'orders_net_amount',
  Roundoff: 'orders_roundoff_amount',
  Payable: 'orders_payable_amount',
  Insurer1Amount: 'orders_insurer1_amount',
  Insurer2Amount: 'orders_insurer2_amount',
  ClientAmount: 'orders_client_amount',
  Comment: 'orders_comment',
  StatusDate: 'orders_status_date',
  StatusHistory: 'orders_status_history',
};

const sale = {
  Id: 'sale_id',
  Key: 'sale_key',
  Active: 'sale_active',
  Date: 'sale_date',
  Serial: 'sale_serial',
  Number: 'sale_number',
  CreditOpen: 'credit_open_amount',
  CreditAdd: 'credit_add_amount',
  CreditUse: 'credit_use_amount',
  CreditClose: 'credit_close_amount',
  Data: 'sale_data',
  SaleOrderData: 'saleorder_data',
  Comment: 'sale_comment'
};

const saleorder = {
  Id: 'saleorder_id',
  Key: 'saleorder_key',
  Active: 'saleorder_active',
  Date: 'saleorder_date',
  Serial: 'saleorder_serial',
  Number: 'saleorder_number',
  RefNo: 'saleorder_ref_number',
  Gross: 'saleorder_gross_amount',
  Discount: 'saleorder_discount_amount',
  Deposit: 'saleorder_deposit_amount',
  Taxable: 'saleorder_taxable_amount',
  Tax1: 'saleorder_tax1_amount',
  Tax2: 'saleorder_tax2_amount',
  Tax3: 'saleorder_tax3_amount',
  Net: 'saleorder_net_amount',
  Roundoff: 'saleorder_roundoff_amount',
  Payable: 'saleorder_payable_amount',
  Insurer1Amount: 'saleorder_insurer1_amount',
  Insurer2Amount: 'saleorder_insurer2_amount',
  ClientAmount: 'saleorder_client_amount',
  CreditAdd: 'credit_add_amount',
  CreditUse: 'credit_use_amount',
  FrameAmount: 'frame_amount',
  HighIndexAmount: 'highindex_amount',
  GiftAmount: 'gift_amount',
  Data: 'saleorder_data',
  Comment: 'saleorder_comment',
};

const saleitem = {
  Id: 'saleitem_id',
  Key: 'saleitem_key',
  Active: 'saleitem_active',
  Date: 'saleitem_date',
  Utncode: 'saleitem_utncode',
  Skucode: 'saleitem_skucode',
  RefNo: 'saleitem_refcode',
  Comment: 'saleitem_comment',
  Data: 'saleitem_data',
  Price: 'saleitem_price',
  Quantity: 'saleitem_quantity',
  Gross: 'saleitem_gross_amount',
  DiscountPercentage: 'saleitem_discount_percentage',
  DiscountAmount: 'saleitem_discount_amount',
  DepositPercentage: 'saleitem_deposit_percentage',
  DepositAmount: 'saleitem_deposit_amount',
  Taxable: 'saleitem_taxable_amount',
  Tax1Percentage: 'saleitem_tax1_percentage',
  Tax2Percentage: 'saleitem_tax2_percentage',
  Tax3Percentage: 'saleitem_tax3_percentage',
  Tax1Amount: 'saleitem_tax1_amount',
  Tax2Amount: 'saleitem_tax2_amount',
  Tax3Amount: 'saleitem_tax3_amount',
  NetAmount: 'saleitem_net_amount',
};

const payout = {
  Id: 'payout_id',
  Key: 'payout_key',
  Active: 'payout_active',
  Date: 'payout_date',
  Serial: 'payout_serial',
  Number: 'payout_number',
  Comment: 'payout_comment',
  ReferenceNumber: 'payout_ref_number',
  Amount: 'payout_amount',
};


const prescription = {
  Id: 'prescription_id',
  Key: 'prescription_key',
  Active: 'prescription_active',
  Date: 'prescription_date',
  TermId: 'term_id',
  Serial: 'prescription_serial',
  Number: 'prescription_number',
  RefNo: 'prescription_ref_number',
  ExpiryDate: 'prescription_expiry_date',
  Comment: 'prescription_comment',
  Observation: 'prescription_observation',
  Note: 'prescription_note',
  Metadata: 'prescription_metadata',
};

const product = {
  Id: 'product_id',
  Key: 'product_key',
  Active: 'product_active',
  Date: 'product_date',
  Serial: 'product_serial',
  Number: 'product_number',
  Name: 'product_name',
  Title: 'product_title',
  Comment: 'product_comment',
  Barcode: 'product_barcode',
  Model: 'product_model_number',
  RefNo: 'product_ref_number',

  PurchasePrice: 'product_purchase_price',
  SalePrice: 'product_sale_price',
  CostPrice: 'product_cost_price',
  DepositPrice: 'product_deposit_price',

  MinSale: 'product_min_sale',
  MaxSale: 'product_max_sale',
  MinPurchase: 'product_min_purchase',
  MaxPurchase: 'product_max_purchase',
  MinStock: 'product_min_stock',
  MaxStock: 'product_max_stock',

  MfgDate: 'product_mfg_date',
  ExpiryDate: 'product_expiry_date',

  Data: 'product_data',
  FileList: 'file_list',
};

const proforma = {
  Id: 'proforma_id',
  Key: 'proforma_key',
  Active: 'proforma_active',
  Date: 'proforma_date',
  TermId: 'term_id',
  Serial: 'proforma_serial',
  Number: 'proforma_number',
  PoNumber: 'proforma_po_number',
  RefNo: 'proforma_ref_number',
  Gross: 'proforma_gross',
  Discount: 'proforma_discount_amount',
  Deposit: 'proforma_deposit_amount',
  Taxable: 'proforma_taxable_amount',
  Tax1: 'proforma_tax1_amount',
  Tax2: 'proforma_tax2_amount',
  Tax3: 'proforma_tax3_amount',
  Tax4: 'proforma_tax4_amount',
  Tax5: 'proforma_tax5_amount',
  Tax: 'proforma_tax_amount',
  Roundoff: 'proforma_roundoff',
  Net: 'proforma_net_amount',
  Payable: 'proforma_payable_amount',
  Comment: 'proforma_comment',
  InternalNote: 'proforma_internal_note',
  PrintableNote: 'proforma_printable_note',
};

const project = {
  Id: 'project_id',
  Key: 'project_key',
  Active: 'project_active',
  Date: 'project_date',
  StartDate: 'project_start_date',
  EndDate: 'project_end_date',
  Address: 'project_address',
  Serial: 'project_serial',
  Number: 'project_number',
  EmployeeList: 'project_employee_list',
  Name: 'project_name',
  Comment: 'project_comment',
  Person: 'project_person',
  Phone: 'project_phone',
  Email: 'project_email',
  Postal: 'project_postal',
  RefNo: 'project_ref_number',
};

const province = {
  Id: 'province_id',
  Key: 'province_key',
  Active: 'province_active',
  Date: 'province_date',
  Name: 'province_name',
  Comment: 'province_comment',
};

const purchase = {
  Id: 'purchase_id',
  Key: 'purchase_key',
  Active: 'purchase_active',
  Date: 'purchase_date',
  OrderDate: 'purchase_order_date',
  Number: 'purchase_number',
  OrderNumber: 'purchase_order_number',
  comment: 'purchase_comment',
  RefNo: 'purchase_ref_number',
  Gross: 'purchase_gross_amount',
  DiscountAmount: 'purchase_discount_amount',
  DepositAmount: 'purchase_deposit_amount',
  TaxableAmount: 'purchase_taxable_amount',
  Tax1Amount: 'purchase_tax1_amount',
  Tax2Amount: 'purchase_tax2_amount',
  Tax3Amount: 'purchase_tax3_amount',
  Tax4Amount: 'purchase_tax4_amount',
  Tax5Amount: 'purchase_tax5_amount',
  TaxAmount: 'purchase_tax_amount',
  Roundoff: 'purchase_roundoff_amount',
  NetAmount: 'purchase_net_amount',
  Count: 'purchase_count',
  Group: 'purchase_group',
};

const option = {
  Id: 'option_id',
  Key: 'option_key',
  Active: 'option_active',
  Date: 'option_date',
  Name: 'option_name',
  Group: 'option_group',
  Comment: 'option_comment',
  Color: 'option_color`',
  Priotity: 'option_priority',
  Sorting: 'option_sorting',
  Value: 'option_value',
}

const stage = {
  Id: 'stage_id',
  Key: 'stage_key',
  Active: 'stage_active',
  Date: 'stage_date',
  Comment: 'stage_comment',
}

const payment = {
  Id: 'payment_id',
  Key: 'payment_key',
  Active: 'payment_active',
  Date: 'payment_date',
  Serial: 'payment_serial',
  Number: 'payment_number',
  Comment: 'payment_comment',
  Amount: 'payment_amount',
  RefNumber: 'payment_ref_number',
  Data: 'payment_data',
}

const supplier = {
  Id: 'supplier_id',
  Key: 'supplier_key',
  Active: 'supplier_active',
  Date: 'supplier_date',
  Name: 'supplier_name',
  Comment: 'supplier_comment',
  Address: 'supplier_address',
  Postal: 'supplier_postal',
  Phone: 'supplier_phone',
  Email: 'supplier_email',
  Web: 'supplier_web',
  Fax: 'supplier_fax',
  Person: 'supplier_person',
  License: 'supplier_license',
  Tax: 'supplier_tax',
  RefNo: 'supplier_ref_number',
  Limit: 'supplier_limit',
}

const payee = {
  Id: 'payee_id',
  Key: 'payee_key',
  Active: 'payee_active',
  Date: 'payee_date',
  Name: 'payee_name',
  Comment: 'payee_comment',
}

const bank = {
  Id: 'bank_id',
  Key: 'bank_key',
  Active: 'bank_active',
  Date: 'bank_date',
  Address: 'bank_address',
  Postal: 'bank_postal',
  Title: 'bank_title',
  Name: 'bank_name',
  Holder: 'bank_holder',
  AccountNo: 'bank_account_no',
  TransitNo: 'bank_transit_no',
  InstituteNo: 'bank_institution_no',
  Phone: 'bank_phone',
  Email: 'bank_email',
  Print: 'bank_print',
  Comment: 'bank_comment',
}

const invoice = {
  Id: 'invoice_id',
  Key: 'invoice_key',
  Active: 'invoice_active',
  Date: 'invoice_date',
  StartDate: 'invoice_start_date',
  EndDate: 'invoice_end_date',
  CreditId: 'credit_id',
  Serial: 'invoice_serial',
  Number: 'invoice_number',
  PoNumber: 'invoice_po_number',
  RefNo: 'invoice_ref_number',
  Gross: 'invoice_gross_amount',
  Discount: 'invoice_discount_amount',
  Deposit: 'invoice_deposit_amount',
  Taxable: 'invoice_taxable_amount',
  Tax1: 'invoice_tax1_amount',
  Tax2: 'invoice_tax2_amount',
  Tax3: 'invoice_tax3_amount',
  Tax4: 'invoice_tax4_amount',
  Tax5: 'invoice_tax5_amount',
  Tax: 'invoice_tax_amount',
  Net: 'invoice_net_amount',
  Roundoff: 'invoice_roundoff_amount',
  Payable: 'invoice_payable_amount',
  Insurer1: 'invoice_insurer1_amount',
  Insurer2: 'invoice_insurer2_amount',
  Client: 'invoice_client_amount',
  Adjustment: 'invoice_adjustment_amount',
  Giftcard: 'invoice_giftcard_amount',
  GiftCardMode: 'invoice_giftcard_mode',
  Comment: 'invoice_comment',
  InternalNote: 'invoice_internal_note',
  PrintableNote: 'invoice_printable_note',
}

const city = {
  Id: 'city_id',
  Key: 'city_key',
  Active: 'city_active',
  Date: 'city_date',
  Name: 'city_name',
  Comment: 'city_comment',
}

const brand = {
  Id: 'brand_id',
  Key: 'brand_key',
  Active: 'brand_active',
  Date: 'brand_date',
  Name: 'brand_name',
  Comment: 'brand_comment',
}

const offer = {
  Id: 'offer_id',
  Key: 'offer_key',
  Active: 'offer_active',
  Date: 'offer_date',
  Name: 'offer_name',
  Coupon: 'offer_coupon',
  Comment: 'offer_comment',
  Percentage: 'offer_percentage',
  Amount: 'offer_amount',
}

const country = {
  Id: 'country_id',
  Key: 'country_key',
  Active: 'country_active',
  Date: 'country_date',
  Name: 'country_name',
  Comment: 'country_comment',
}

const role =  {
  Id: 'role_id',
  Key: 'role_key',
  Active: 'role_active',
  Date: 'role_date',
  Name: 'role_name',
  Comment: 'role_comment',
  formList: 'form_list',
  reportList: 'report_list',
  privilegeList: 'privilege_list',
  groupList: 'group_list',
  menuList: 'menu_list',
}

const recdoctor = {
  Id: 'recdoctor_id',
  Key: 'recdoctor_key',
  Active: 'recdoctor_active',
  Date: 'recdoctor_date',
  FirstName: 'recdoctor_first_name',
  MiddleName: 'recdoctor_middle_name',
  LastName: 'recdoctor_last_name',
  FullName: 'recdoctor_first_name,recdoctor_middle_name,recdoctor_last_name',
  ShortCode: 'recdoctor_short_code',
  Dob: 'recdoctor_dob',
  Cell: 'recdoctor_cell',
  Phone: 'recdoctor_phone',
  Mobile: 'recdoctor_mobile',
  Email: 'recdoctor_email',
  Fax: 'recdoctor_fax',
  Qualification: 'recdoctor_qualification',
  ClinicName: 'recdoctor_clinic_name',
  practitionerCode: 'recdoctor_practitioner_code',
  payToULI: 'recdoctor_pay_to_uli',
  locumArrangement: 'recdoctor_locum_arrangement',
  skillCode: 'recdoctor_skill_code',
  facilityNumber: 'recdoctor_facility_number',
  functionalCentre: 'recdoctor_functional_centre',
  payToCode: 'recdoctor_pay_to_code',
  businessArrangement: 'recdoctor_business_arrangement',
  coopCode: 'recdoctor_coop_code',
  licenseNumber: 'recdoctor_license_number',
  File: 'recdoctor_file',
  Comment: 'recdoctor_comment',
  Color: 'recdoctor_color',
  Data: 'recdoctor_data',
  Address: 'recdoctor_address',
  Postal: 'recdoctor_postal',
};

const doctor = {
  Id: 'doctor_id',
  Key: 'doctor_key',
  Active: 'doctor_active',
  Date: 'doctor_date',
  FirstName: 'doctor_first_name',
  MiddleName: 'doctor_middle_name',
  LastName: 'doctor_last_name',
  FullName: 'doctor_first_name,doctor_middle_name,doctor_last_name',
  ShortName: 'doctor_short_name',
  ShortCode: 'doctor_short_code',
  Dob: 'doctor_dob',
  Cell: 'doctor_cell',
  Phone: 'doctor_phone',
  Mobile: 'doctor_mobile',
  Email: 'doctor_email',
  Fax: 'doctor_fax',
  Qualification: 'doctor_qualification',
  ClinicName: 'doctor_clinic_name',
  PractitionerCode: 'doctor_practitioner_code',
  PayToULI: 'doctor_pay_to_uli',
  LocumArrangement: 'doctor_locum_arrangement',
  SkillCode: 'doctor_skill_code',
  FacilityNumber: 'doctor_facility_number',
  FunctionalCentre: 'doctor_functional_centre',
  PayToCode: 'doctor_pay_to_code',
  BusinessArrangement: 'doctor_business_arrangement',
  CoopCode: 'doctor_coop_code',
  LicenseNumber: 'doctor_license_number',
  File: 'doctor_file',
  Comment: 'doctor_comment',
  Color: 'doctor_color',
  Data: 'doctor_data',
  Address: 'doctor_address',
  Postal: 'doctor_postal',
};

const item = {
  Id : 'item_id',
  Key: 'item_key',
  Active: 'item_active',
  All: 'item_date,item_price,item_quantity,item_gross_amount,item_discount_percentage,item_discount_amount,item_deposit_percentage,item_deposit_amount,item_tax1_percentage,item_tax1_amount,item_net_amount,item_comment',
  Date: 'item_date',
  UTN: 'item_utncode',
  SKU: 'item_skucode',
  ItemStatusId: 'item_status_id',
  ItemStatusName: 'item_status_name',
  OrderStatusId: 'order_status_id',
  OrderStatusName: 'order_status_name',
  StockStatusId: 'stock_status_id',
  StockStatusName: 'stock_status_name',
  Price: 'item_price',
  Quantity: 'item_quantity',
  Gross: 'item_gross_amount',
  DiscountP: 'item_discount_percentage',
  DiscountA: 'item_discount_amount',
  DepositP: 'item_deposit_percentage',
  DepositA: 'item_deposit_amount',
  Taxable: 'item_taxable_amount',
  Tax1P: 'item_tax1_percentage',
  Tax2P: 'item_tax2_percentage',
  Tax3P: 'item_tax3_percentage',
  Tax1A: 'item_tax1_amount',
  Tax2A: 'item_tax2_amount',
  Tax3A: 'item_tax3_amount',
  Net: 'item_net_amount',
  Paid: 'item_paid_amount',
  Comment: 'item_comment',
  History: 'item_history',
}

const purchaseorder = {
  Id: 'purchaseorder_id',
  Key: 'purchaseorder_key',
  CompanyId: 'company_id',
  LocationId: 'location_id',
  UserId: 'user_id',
  Active: 'purchaseorder_active',
  Date: 'purchaseorder_date',
  DeliveryDate: 'pruchaseorder_delivery_date',
  SupplierId: 'supplier_id',
  TermId: 'term_id',
  AddressId: 'address_id',
  ProjectId: 'project_id',
  Type: 'purchaseorder_type',
  Serial: 'purchaseorder_serial',
  No: 'purchaseorder_no',
  Name: 'purchaseorder_name',
  RefNo: 'purchase_order_ref_number',
  GrossAmount: 'purchaseorder_gross_amount',
  DiscountAmount: 'purchaseorder_discount_amount',
  TaxableAmount: 'purchaseorder_taxable_amount',
  Tax1: 'purchaseorder_tax1',
  Tax2: 'purchaseorder_tax2',
  Tax3: 'purchaseorder_tax3',
  TaxAmount: 'purchaseorder_tax_amount',
  Roundoff: 'purchaseorder_roundoff',
  NetAmount: 'purchaseorder_net_amount',
  Address: 'purchaseorder_address',
}

const rack = {
  Id: 'rack_id',
  Key: 'rack_key',
  CompanyId: 'company_id',
  LocationId: 'location_id',
  UserId: 'user_id',
  Active: 'rack_active',
  Date: 'rack_date',
  WarehouseId: 'warehouse_id',
  Name: 'rack_name',
  Comment: 'rack_comment',
  RefNo: 'rack_ref_number',
}

const rate = {
  Id: 'rate_id',
  Key: 'rate_key',
  CompanyId: 'company_id',
  LocationId: 'location_id',
  UserId: 'user_id',
  Active: 'rate_active',
  Date: 'rate_date',
  Name: 'rate_name',
  Comment: 'rate_comment',
  ProvinceId: 'province_id',
  DepartmentId: 'department_id',
  FormId: 'form_id',
  CommonId: 'common_id',
  TypeId: 'type_id',
  Num1: 'rate_num1',
  Num2: 'rate_num2',
  Num3: 'rate_num3',
  Num4: 'rate_num4',
  Num5: 'rate_num5',
  Amount1: 'rate_amount1',
  Amount2: 'rate_amount2',
  Amount3: 'rate_amount3',
  Amount4: 'rate_amount4',
  Amount5: 'rate_amount5',
}

const recall = {
  Id: 'recall_id',
  Key: 'recall_key',
  CompanyId: 'company_id',
  LocationId: 'location_id',
  UserId: 'user_id',
  Active: 'recall_active',
  Date: 'recall_date',
  CallDate: 'recall_call_date',
  CallTime: 'recall_call_time',
  SegmentId: 'segment_id',
  TypeId: 'type_id',
  StatusId: 'status_id',
  FormId: 'form_id',
  CommonId: 'common_id',
  ClientId: 'client_id',
  DoctorId: 'doctor_id',
  PriorityId: 'priority_id',
  Comment: 'recall_comment',
}

const referral = {
  Id: 'referral_id',
  Key: 'referral_key',
  CompanyId: 'company_id',
  LocationId: 'location_id',
  UserId: 'user_id',
  Active: 'referral_active',
  Date: 'referral_date',
  TypeId: 'type_id',
  StatusId: 'status_id',
  ClientId: 'client_id',
  DoctorId: 'doctor_id',
  RecDoctorTo: 'recdoctor_to',
  RecDoctorCc: 'recdoctor_cc',
  ExamId: 'exam_id',
  TemplateId: 'template_id',
  Name: 'referral_name',
  Comment: 'referral_comment',
  Metadata: 'referral_metadata',
}

const remittance = {
  Id: 'remittance_id',
  Key: 'remittance_key',
  CompanyId: 'company_id',
  LocationId: 'location_id',
  UserId: 'user_id',
  Active: 'remittance_active',
  Date: 'remittance_date',
  TypeId: 'type_id',
  StatusId: 'status_id',
  Name: 'remittance_name',
  File: 'remittance_file',
  Count: 'remittance_count',
  Data: 'remittance_data',
  Comment: 'remittance_comment',
  RefNo: 'remittance_ref_number',
}

const report = {
  Id: 'report_id',
  Key: 'report_key',
  CompanyId: 'company_id',
  LocationId: 'location_id',
  UserId: 'user_id',
  Active: 'report_active',
  Date: 'report_date',
  StartDate: 'report_start_date',
  EndDate: 'report_end_date',
  TypeId: 'type_id',
  FormId: 'form_id',
  Name: 'report_name',
  Comment: 'report_comment',
  Note: 'report_note',
  Style: 'report_style',
  Sql: 'report_sql',
  Where: 'report_where',
  Title: 'report_title',
  ColumnData: 'report_column_data',
  ChartData: 'report_chart_data',
  Session: 'report_session',
  DateBy: 'report_dateby',
  OrderBy: 'report_orderby',
  SortBy: 'report_sort',
  GroupBy: 'report_groupby',
  SubTotal: 'report_sub_total',
  GrandTotal: 'report_grand_total',
  Sno: 'report_sno',
  Orientation: 'report_orientation',
  Comparation: 'report_comparation',
  LinkPath: 'report_link_path',
  LinkId: 'report_link_id',
  LinkWidth: 'report_link_width',
}

const requisition = {
  Id: 'requisition_id',
  Key: 'requisition_key',
  CompanyId: 'company_id',
  LocationId: 'location_id',
  UserId: 'user_id',
  Active: 'requisition_active',
  Date: 'requisition_date',
  ProjectId: 'project_id',
  AddressId: 'address_id',
  TypeId: 'requisition_type',
  Serial: 'requisition_serial',
  No: 'requisition_no',
  Comment: 'requisition_comment',
  RefNo: 'requisition_ref_number',
}

const schedule = {
  Id: 'schedule_id',
  Key: 'schedule_key',
  CompanyId: 'company_id',
  LocationId: 'location_id',
  UserId: 'user_id',
  Active: 'schedule_active',
  Date: 'schedule_date',
  StartDate: 'schedule_start_date',
  EndDate: 'schedule_end_date',
  StartTime: 'schedule_start_time',
  EndTime: 'schedule_end_time',
  Comment: 'schedule_comment',
}

const segment = {
  Id: 'segment_id',
  Key: 'segment_key',
  Active: 'segment_active',
  Date: 'segment_date',
  Name: 'segment_name',
  Group: 'segment_group',
  Comment: 'segment_comment',
  Color: 'segment_color',
  Sorting: 'segment_sorting',
}

const subcategory = {
  Id: 'subcategory_id',
  Key: 'subcategory_key',
  CompanyId: 'company_id',
  LocationId: 'location_id',
  UserId: 'user_id',
  Active: 'subcategory_active',
  Date: 'subcategory_date',
  CategoryId: 'category_id',
  Name: 'subcategory_name',
  Comment: 'subcategory_comment',
  Sorting: 'subcategory_sorting',
}

const submitter = {
  Id: 'submitter_id',
  Key: 'submitter_key',
  CompanyId: 'company_id',
  LocationId: 'location_id',
  UserId: 'user_id',
  Active: 'submitter_active',
  Date: 'submitter_date',
  Name: 'submitter_name',
  Comment: 'submitter_comment',
  Prefix: 'submitter_prefix',
  TransactionType: 'submitter_transaction_type',
  SegmentType: 'submitter_segment_type',
}

const tasks = {
  Id: 'tasks_id',
  Key: 'tasks_key',
  Active: 'tasks_active',
  Date: 'tasks_date',
  StartDate: 'tasks_start_date',
  EndDate: 'tasks_end_date',
  Name: 'tasks_name',
  Comment: 'tasks_comment',
  ReceiverList: 'tasks_receiver_list',
}

const tax = {
  Id: 'tax_id',
  Key: 'tax_key',
  CompanyId: 'company_id',
  LocationId: 'location_id',
  UserId: 'user_id',
  Active: 'tax_active',
  Date: 'tax_date',
  Name: 'tax_name',
  Comment: 'tax_comment',
  Percentage: 'tax_percentage',
}

const template = {
  Id: 'template_id',
  Key: 'template_key',
  CompanyId: 'company_id',
  LocationId: 'location_id',
  UserId: 'user_id',
  Active: 'template_active',
  Date: 'template_date',
  TypeId: 'type_id',
  ActionId: 'action_id',
  DefaultId: 'default_id',
  Name: 'template_name',
  Comment: 'template_comment',
  Data: 'template_data',
}

const unit = {
  Id: 'unit_id',
  Key: 'unit_key',
  CompanyId: 'company_id',
  LocationId: 'location_id',
  UserId: 'user_id',
  Active: 'unit_active',
  Date: 'unit_date',
  Name: 'unit_name',
  Comment: 'unit_comment',
}

const value = {
  Id: 'value_id',
  Key: 'value_key',
  CompanyId: 'company_id',
  LocationId: 'location_id',
  UserId: 'user_id',
  Active: 'value_active',
  Date: 'value_date',
  ControlId: 'control_id',
  Name: 'value_name',
}

const warehouse = {
  Id: 'warehouse_id',
  Key: 'warehouse_key',
  CompanyId: 'company_id',
  LocationId: 'location_id',
  UserId: 'user_id',
  Active: 'warehouse_active',
  Date: 'warehouse_date',
  Name: 'warehouse_name',
  Comment: 'warehouse_comment',
  RefNo: 'warehouse_ref_number',
  Address: 'warehouse_address',
  Postal: 'warehouse_postal',
  CityId: 'city_id',
}

const employee = {
  Id: 'employee_id',
  Key: 'employee_key',
  CompanyId: 'company_id',
  LocationId: 'location_id',
  UserId: 'user_id',
  Active: 'employee_active',
  Date: 'employee_date',
  DesignationId: 'designation_id',
  TypeId: 'type_id',
  GenderId: 'gender_id',
  MaritalId: 'marital_id',
  BloodGroupId: 'blood_group_id',
  NationalityId: 'nationality_id',
  SegmentId: 'segment_id',
  RoleId: 'role_id',
  RefNo: 'employee_refno',
  FirstName: 'employee_first_name',
  MiddleName: 'employee_middle_name',
  LastName: 'employee_last_name',
  Phone: 'employee_phone',
  Cell: 'employee_cell',
  Mobile: 'employee_mobile',
  Email: 'employee_email',
  FatherName: 'employee_father_name',
  MotherName: 'employee_mother_name',
  Dob: 'employee_dob',
  Login: 'employee_login',
  Pass: 'employee_pass',
  Comment: 'employee_comment',
  Data: 'employee_data',
}

export const Name = {
  Address: address,
  Appointment: appointment,
  Bank: bank,
  Billing: billing,
  Brand: brand,
  Category: category,
  Chat: chat,
  Check: check,
  City: city,
  Claim: claim,
  Client: client,
  Code: code,
  Common: common,
  Communication: communication,
  Company: company,
  Control: control,
  Country: country,
  Credit: credit,
  Database: database,
  Daybook: daybook,
  Delivery: delivery,
  Dispense: dispense,
  Release: release,
  Dispatch: dispatch,
  RecDoctor: recdoctor,
  Doctor: doctor,
  Document: document,
  Employee: employee,
  Estimate: estimate,
  Exam: exam,
  ExamTemplate: examtemplate,
  ExamType: examtype,
  Feature: feature,
  Form: form,
  Group: group,
  Inquiry: inquiry,
  Insurance: insurance,
  Insurer: insurer,
  Inventory: inventory,
  Specification: specification,
  Invoice: invoice,
  Issue: issue,
  Item: item,
  Language: language,
  Location: location,
  Logs: logs,
  Medication: medication,
  Merge: merge,
  Metric: metric,
  Note: note,
  Offer: offer,
  OfficeHour: officehour,
  Missing: missing,
  Option: option,
  Orders: orders,
  Payout: payout,
  Payment: payment,
  Stage: stage,
  Prescription: prescription,
  Privilege: privilege,
  Product: product,
  Proforma: proforma,
  Project: project,
  Province: province,
  Purchase: purchase,
  PurchaseOrder: purchaseorder,
  Rack: rack,
  Rate: rate,
  Recall: recall,
  Referral: referral,
  Remittance: remittance,
  Report: report,
  Requisition: requisition,
  Role: role,
  Sale: sale,
  SaleOrder: saleorder,
  SaleItem: saleitem,
  Schedule: schedule,
  Segment: segment,
  Server: server,
  Session: session,
  Setting: setting,
  Subcategory: subcategory,
  Submitter: submitter,
  Supplier: supplier,
  Payee: payee,
  Tasks: tasks,
  Tax: tax,
  Template: template,
  Timezone: timezone,
  Token: token,
  Unit: unit,
  User: user,
  Value: value,
  Warehouse: warehouse,
};
